import { useMemo, useEffect, useState } from "react";
import Select from "react-select";
import { useQuery } from "@tanstack/react-query";
import { Controller } from "react-hook-form";
import { STALE_TIME } from "utils/constants";
import { fetchAllocateZoneById } from "services/allocateZone";
import { useSelector } from "react-redux";
import { fetchZonesDD } from "services/dropdown";

const ZoneDropdownMultiSelector = ({
  errors,
  control,
  setValue,
  watch,
  mappedData,
  login,
  defaultValue,
  allZone,
}) => {
  const selectedZones = watch("zone_id");

  const [zoneId, setZoneId] = useState(localStorage.getItem("zone_id") || null);
  const auth = useSelector((state) => state.jwtAuthreducer);

  const {
    data: Zones,
    isLoading,
    error,
    refetch,
  } = useQuery(
    allZone
      ? ["zones-all"]
      : ["fetch-zone-by-id", auth?.user?.employee_code_id],
    () =>
      allZone
        ? fetchZonesDD({ ...login })
        : fetchAllocateZoneById({
            employee_code_id: auth?.user?.employee_code_id,
          }),
    {
      staleTime: STALE_TIME,
      enabled: allZone ? true : !!auth?.user?.employee_code_id,
    },
  );

  const optionsList = useMemo(() => {
    const rawData = allZone ? Zones?.data?.zone_data : Zones?.data;

    if (!Array.isArray(rawData)) return [];

    return rawData.map((item) => ({
      value: item?.zone_id,
      label: allZone ? item?.zone_name : item?.zone_obj?.zone_name,
    }));
  }, [Zones, allZone]);

  useEffect(() => {
    if (login) refetch();
  }, [login, refetch]);

  // useEffect(() => {
  //   if (defaultValue?.length && optionsList.length) {
  //     const selectedOptions = optionsList.filter((option) =>
  //       defaultValue.some((d) => d.zone_id === option.value)
  //     );

  //     setValue(
  //       "zone_id",
  //       selectedOptions.map((opt) => opt.value)
  //     );

  //     setValue(
  //       "zone_name",
  //       selectedOptions.map((opt) => opt.label)
  //     );
  //   }
  // }, [defaultValue, optionsList, setValue]);

  useEffect(() => {
    if (defaultValue && optionsList.length) { 
      const selectedOption = optionsList.find(
        (option) => option.value === defaultValue,
      );
 
      if (selectedOption) {
        setValue("zone_id", [selectedOption.value]);
        setValue("zone_name", [selectedOption.label]);
      }
    }
  }, [defaultValue, optionsList, setValue]);

  const options = mappedData
    ? optionsList.filter((option) => !mappedData.includes(option.label))
    : optionsList;

  useEffect(() => {
    if (Zones && selectedZones?.length !== 0) {
      const defaultValues = mappedData?.map((label) =>
        optionsList.find((option) => option.value === label?.zone_id),
      );

      if (defaultValues) {
        const defaultIds = defaultValues.map((opt) => opt?.value);
        setValue("zone_id", defaultIds);
        setValue(
          "zone_name",
          defaultValues.map((opt) => opt?.label),
        );
      }
    }
  }, [mappedData, optionsList, setValue]);

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading Zone Data</div>;

  return (
    <Controller
      name="zone_id"
      control={control}
      rules={{ required: "Zone selection is required" }}
      render={({ field }) => (
        <Select
          {...field}
          options={options}
          isMulti
          isClearable
          placeholder="Select Zones"
          menuPortalTarget={document.body}
          value={options.filter((option) =>
            selectedZones?.includes(option.value),
          )}
          onChange={(selectedOptions) => {
            const values = selectedOptions
              ? selectedOptions.map((option) => option.value)
              : [];
            const labels = selectedOptions
              ? selectedOptions.map((option) => option.label)
              : [];

            field.onChange(values);
            setValue("zone_id", values);
            setValue("zone_name", labels);
          }}
          className={`react-select-container ${
            errors.zone_id ? "is-invalid" : ""
          }`}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            control: (base) => ({
              ...base,
              minHeight: "42px",
              maxHeight: "auto",
              overflowY: "auto",
            }),
            valueContainer: (base) => ({
              ...base,
              maxHeight: "42px",
              overflowY: "auto",
            }),
            multiValue: (base) => ({
              ...base,
              maxWidth: "100%",
            }),
          }}
        />
      )}
    />
  );
};
export default ZoneDropdownMultiSelector;
